import React from 'react';
import { getUser } from '../../utils';
import { Auth } from 'aws-amplify';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { useSnackbarContext } from '../../contexts/Snackbar';
import { useHistory } from 'react-router-dom';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import SubmitButton from '../SubmitButton';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
  field: { width: 250, marginBottom: theme.spacing(2) },
}));

export default function EditName({ firstName, lastName }) {
  const classes = useStyles();
  const history = useHistory();
  const snackbar = useSnackbarContext();

  return (
    <Container className={classes.root}>
      <Formik
        initialValues={{ firstName, lastName }}
        validationSchema={yup.object({
          firstName: yup.string().required('First name is required'),
          lastName: yup.string().required('Last name is required'),
        })}
        onSubmit={async (values) => {
          try {
            const user = await getUser();
            await Auth.updateUserAttributes(user, {
              'custom:first_name': values.firstName,
              'custom:last_name': values.lastName,
            });
            snackbar.show('Name updated successfully.', 'success');
            setTimeout(() => history.push('/account'), 500);
          } catch (error) {
            snackbar.show(error.message, 'error');
          }
        }}
      >
        {({ isSubmitting }) => {
          return (
            <Form>
              <div className={classes.field}>
                <Field
                  component={TextField}
                  variant="outlined"
                  name="firstName"
                  label="First name"
                  fullWidth
                />
              </div>
              <div className={classes.field}>
                <Field
                  component={TextField}
                  variant="outlined"
                  name="lastName"
                  label="Last name"
                  fullWidth
                />
              </div>
              <SubmitButton isSubmitting={isSubmitting} text="Save" />
            </Form>
          );
        }}
      </Formik>
    </Container>
  );
}
